export enum Modals {
  CustomReport = "CustomReportModal",
  Confirmation = "ConfirmationModal",
  NewRequest = "NewRequestModal",
  NewService = "NewServiceModal"
}
